<template>
  <div class="focused-completion-prompt">
    <section
        class="focused-completion-prompt__card"
        role="group"
        aria-labelledby="focused-completion-prompt-title"
        aria-describedby="focused-completion-prompt-message"
    >
      <h2 id="focused-completion-prompt-title" class="focused-completion-prompt__title">
        {{ $t('app.assessment_mode.text.input.follow_up_questions_header') }}
      </h2>
      <div class="focused-completion-prompt__body">
        <p id="focused-completion-prompt-message" class="focused-completion-prompt__message">
          {{ $t('app.assessment_mode.text.completion_prompt.message') }}
        </p>
        <div class="focused-completion-prompt__actions">
          <button
              type="button"
              data-analytics-skip
              class="focused-completion-prompt__button focused-completion-prompt__back"
              :disabled="disabled"
              @click="$emit('back')"
          >
            <v-icon small class="focused-completion-prompt__back-icon" aria-hidden="true">{{ backIcon }}</v-icon>
            <span>{{ $t('app.assessment_mode.coming_soon.back') }}</span>
          </button>
          <div class="focused-completion-prompt__primary">
            <button
                type="button"
                data-analytics-skip
                class="focused-completion-prompt__button focused-completion-prompt__continue"
                :disabled="disabled"
                @click="$emit('continue')"
            >
              {{ $t('app.assessment_mode.text.completion_prompt.continue') }}
            </button>
            <button
                type="button"
                data-analytics-skip
                class="focused-completion-prompt__button focused-completion-prompt__complete"
                :disabled="disabled"
                @click="$emit('complete')"
            >
              {{ $t('app.assessment_mode.text.completion_prompt.complete') }}
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';

export default defineComponent({
  name: 'FocusedCompletionPrompt',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['complete', 'continue', 'back'],

  computed: {
    backIcon(): string {
      return this.$vuetify?.rtl ? mdiChevronRight : mdiChevronLeft;
    },
  },
});
</script>
